import { faker } from '@faker-js/faker';
import { cleanup } from '@testing-library/react';
import { HttpResponse, http } from 'msw';
import { setupServer } from 'msw/node';

import constants from '../constants';
import redux from '../redux';
import translations from '../translations';

translations.init();

describe('customer group selector failure while reading customers', () => {
  // create a mock server
  const server = setupServer(
    http.get(constants.endpoints.get.hierarchySummary, () => {
      return HttpResponse.json({ status: 500 }, { status: 500 });
    }),
    http.get(constants.endpoints.get.context, () => {
      return HttpResponse.json({
        customer_group_uuid: faker.string.uuid(),
        customer_uuid: faker.string.uuid(),
        enforce: 'customer_group',
        partner_uuid: faker.string.uuid(),
      });
    }),
  );

  beforeAll(() => {
    server.listen();
  });

  afterAll(() => {
    server.close();
  });

  afterEach(() => {
    server.resetHandlers();
    cleanup();
  });

  it('should fail to read hierarchy summary', async () => {
    redux.store.dispatch(redux.api.getData());

    await new Promise((resolve) => {
      setTimeout(resolve, 100);
    });

    expect(redux.store.getState().api.data).toStrictEqual([]);
    expect(redux.store.getState().api.isError).toStrictEqual(true);
  });
});
